﻿window.cObjetHebergementMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Hébergement"; }
    this.mGetAttributBase = function () { return "la " }
    this.mGetNewLib = function () { return "Nouvel hébergement"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data == 'undefined' && objet.data == null) { txt = "Hébergement" }
        else {
            txt = objet.data.nom
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-person-shelter'></i>");
    }

    this.mGetRadiusImage = function () { return "10px" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetNewNomHebergement = function () {
        var idx = 1
        while (Me.objet.bddRef.mGetArray("hebergement").filter(function (ch) { return ch.nom == "Hébergement " + idx }).length > 0) {
            idx += 1
        }
        return "Hébergement " + idx
    }

    this.mCreateNewHebergement = function (nomHebergement, funcOk) {
        var pop = $("<div/>").appendTo("body").dxCtrlPopupBase({
            showMaximize: false,
            title: "Nouvel hébergement",
            height: "auto",
            width: 500,
            contentTemplate: function (contentElement) {
                contentElement.css("padding-top", "0")
                var dxNom = $("<div style='display:inline-block;width:100%;'/>").appendTo(contentElement).dxCtrlTextBox({
                    labelMode: "floating",
                    label: "Nom de l'hébergement",
                    value: (nomHebergement ? nomHebergement : ""),
                    onValueChanged: function (e) {
                    },
                    onContentReady: function (e) {
                        window.setTimeout(function () {
                            e.component.focus()
                        }, 500)
                    }
                }).dxCtrlTextBox("instance")
                var dxChkVirtuel = $("<div style='margin:20px 0;'/>").appendTo(contentElement).dxCtrlCheckBox({
                    text: "Hébergement virtuel",
                    value: false,
                    hint: "Un hébergement virtuel regroupe plusieurs hébergements physiques au sein d’une même entité. Il permet de proposer des offres basées sur un ensemble d’hébergements plutôt que sur chaque unité individuellement.<br/><br/>Exemple: si vous souhaitez louer l’intégralité de votre chambre d’hôtes(avec toutes ses chambres) sous la forme d’un gîte, vous pouvez créer un hébergement virtuel regroupant l’ensemble des chambres concernées."
                }).dxCtrlCheckBox("instance")
                mAddButtonOkAnnuler(contentElement, function () {
                    Me.objet.bddRef.mAjaxCall({
                        command: "creationhebergement",
                        nom: ((dxNom.option("value") == null) ? Me.objet.bddRef.getObjet("hebergement").objetMetier.mGetNewNomHebergement() : dxNom.option("value")),
                        is_virtuel: (dxChkVirtuel.option("value") ? "1" : "0")
                    }, function (data) {
                        var newData = Me.objet.bddRef.getObjet("hebergement", data.bddadd.hebergement[0].id_hebergement).data
                        Me.objet.bddRef.triggerFunctionOnModifiedItemData("hebergement", "new", newData)
                        funcOk(newData)
                    })
                    pop.hide()
                }, function () { pop.hide(); }, "Annuler", "Valider")
            }
        }).dxCtrlPopupBase("instance")
        pop.show()
    }

    this.mGetLstHebergement = function () {
        return Me.objet.bddRef.mGetArray("hebergement")
    }
    this.mGetLstReservationHebergement = function () {
        return Me.objet.bddRef.mGetArray("reservation_hebergement").filter(function (bkCh) { return bkCh.id_hebergement == objet.data.id_hebergement })
    }
    this.mGetLstHebergementLinked = function () {
        return Me.objet.bddRef.mGetArray("hebergement").filter(function (bkChChild) {
            return Me.objet.bddRef.mGetArray("hebergement_hebergement").filter(function (bkCh) {
                return bkCh.id_hebergement_virtuel == objet.data.id_hebergement && bkCh.id_hebergement == bkChChild.id_hebergement
            }).length > 0
        })
    }
    this.mGetNbInHebergementVirtuel = function () {
        return Me.objet.bddRef.mGetArray("hebergement_hebergement").filter(function (bkCh) { return bkCh.id_hebergement == objet.data.id_hebergement }).length
    }
    this.mGetLstHebergementAgendaCentrale = function () {
        return Me.objet.bddRef.mGetArray("hebergement_agenda_centrale").filter(function (o) { return o.id_hebergement == objet.data.id_hebergement })
    }
    this.mGetLstHebergementAgendaCentraleRdv = function () {
        var lstAgendaCentrale = Me.mGetLstHebergementAgendaCentrale()
        return Me.objet.bddRef.mGetArray("hebergement_agenda_centrale_rdv").filter(function (bkCh) {
            return lstAgendaCentrale.filter(function (o2) { return bkCh.hebergement_agenda_centrale == o2.hebergement_agenda_centrale }).length > 0
        })
    }

    this.mGetLstDateOccupation = function (excluDataResaHeberg) {
        var lstDatOccup = []
        this.mGetLstReservationHebergement().filter(function (dataResaHeberg) {
            var dataReservation = objet.bddRef.getObjet("reservation", dataResaHeberg.id_reservation).data
            if (dataResaHeberg.id_reservation_hebergement_parent == null || (dataResaHeberg.id_reservation_hebergement_parent != null && dataReservation.id_statut_resa != 3)) {
                if (!excluDataResaHeberg || excluDataResaHeberg.id_reservation_hebergement != dataResaHeberg.id_reservation_hebergement) {
                    var idStatutResa = dataReservation.id_statut_resa
                    return (idStatutResa > 0 && idStatutResa < 4) || idStatutResa == 5
                } else { return false }
            } else { return false }
        }).forEach(function (dataResaHeberg) {
            lstDatOccup.push({
                date_debut: new Date(dataResaHeberg.date_debut),
                date_fin: new Date(dataResaHeberg.date_fin)
            })
        })
        return lstDatOccup
    }

    //toutes les plages de dates ou tous les hébergement sont occupé
    this.mGetLstDateOccupationAll = function (nbPers, txOccupMinimal) {
        var lstDates = []
        objet.bddRef.mGetArray("hebergement").forEach(function (dataHebergement) {
            var objHeberg = objet.bddRef.getObjet(dataHebergement)
            if (dataHebergement.date_abandon == null && dataHebergement.is_virtuel == "0" && (txOccupMinimal == null || objHeberg.objetMetier.mGetMaxTauxOccupation(nbPers).taux_occupation > txOccupMinimal)) {
                if (!nbPers || nbPers <= objet.bddRef.getObjet(dataHebergement).objetMetier.mGetNbPlaceMax()) {
                    var lstDatOccup = []
                    objHeberg.objetMetier.mGetLstReservationHebergement().filter(function (dataResaHeberg) {
                        var dataResa = objet.bddRef.getObjet(dataResaHeberg).objetMetier.mGetReservation()
                        if (dataResa) {
                            var idStatutResa = dataResa.id_statut_resa
                            if (dataResaHeberg.id_reservation_hebergement_parent != null) {
                                return (idStatutResa > 0 && idStatutResa < 3) || idStatutResa == 5
                            } else {
                                return (idStatutResa > 0 && idStatutResa < 4) || idStatutResa == 5
                            }
                        } else {
                            return false
                        }
                        //var idStatutResa = objet.bddRef.getObjet("reservation", dataResaHeberg.id_reservation).data.id_statut_resa
                        //return (idStatutResa > 0 && idStatutResa < 4) || idStatutResa == 5
                    }).forEach(function (dataResaHeberg) {
                        lstDatOccup.push({
                            date_debut: new Date(dataResaHeberg.date_debut),
                            date_fin: new Date(dataResaHeberg.date_fin)
                        })
                    })
                    objet.bddRef.mGetArray("hebergement_agenda_centrale_rdv").filter(function (o) {
                        return o.id_hebergement == dataHebergement.id_hebergement && o.date_deleted == null && o.id_reservation_habergement == null
                    }).forEach(function (o) {
                        lstDatOccup.push({
                            date_debut: new Date(o.date_debut),
                            date_fin: new Date(o.date_fin)
                        })
                    })
                    lstDates.push(lstDatOccup)
                }
            }
        })
        if (lstDates.length == 0) { return lstDates }
        else { return intersectMultipleLists(lstDates) }

        function intersectIntervals(listA, listB) {
            const result = [];
            for (const a of listA) {
                for (const b of listB) {
                    const start = new Date(Math.max(
                        new Date(a.date_debut),
                        new Date(b.date_debut)
                    ));

                    const end = new Date(Math.min(
                        new Date(a.date_fin),
                        new Date(b.date_fin)
                    ));

                    if (start <= end) {
                        result.push({
                            date_debut: start,
                            date_fin: end
                        });
                    }
                }
            }
            return result;
        }
        function intersectMultipleLists(lists) {
            return lists.reduce((acc, current) => {
                return intersectIntervals(acc, current);
            });
        }
    }

    this.mIsLibre = function (dateDebut, dateFin, dataReservationEnCours) {
        var datD = new Date(dateDebut.getFullYear(), dateDebut.getMonth(), dateDebut.getDate(), 23, 55, 0)
        var datF = (!dateFin ? (new Date(dateDebut)).addDays(1) : dateFin)
        datF = new Date(dateFin.getFullYear(), dateFin.getMonth(), dateFin.getDate(), 1, 0, 0)
        var lstReservationHebergement = this.mGetLstReservationHebergement().filter(function (dataResaHeberg) {
            //if (!excluDataResaHeberg || excluDataResaHeberg.id_reservation_hebergement != dataResaHeberg.id_reservation_hebergement) {
            var dataResa = objet.bddRef.getObjet(dataResaHeberg).objetMetier.mGetReservation()
            if (dataResa) {
                var lstIdStatutResa = []
                if (dataReservationEnCours && dataReservationEnCours.id_reservation == dataResaHeberg.id_reservation) {
                    lstIdStatutResa.push(0)
                }
                if (dataResaHeberg.id_reservation_hebergement_parent != null) {
                    lstIdStatutResa.push(1)
                    lstIdStatutResa.push(2)
                    lstIdStatutResa.push(5)
                    //return (idStatutResa > 0 && idStatutResa < 3) || idStatutResa == 5
                } else {
                    lstIdStatutResa.push(1)
                    lstIdStatutResa.push(2)
                    lstIdStatutResa.push(3)
                    lstIdStatutResa.push(5)
                    //return (idStatutResa > 0 && idStatutResa < 4) || idStatutResa == 5
                }
                return lstIdStatutResa.contains(parseInt(dataResa.id_statut_resa))
                //var idStatutResa = dataResa.id_statut_resa
                //if (dataResaHeberg.id_reservation_hebergement_parent != null) {
                //    return (idStatutResa > 0 && idStatutResa < 3) || idStatutResa == 5
                //} else {
                //    return (idStatutResa > 0 && idStatutResa < 4) || idStatutResa == 5
                //}
            } else {
                return false
            }
            //var idStatutResa = objet.bddRef.getObjet("reservation", dataResaHeberg.id_reservation).data.id_statut_resa
            //return (idStatutResa > 0 && idStatutResa < 4) || idStatutResa == 5
            //} else { return false }
        })
        if (lstReservationHebergement.filter(function (dataResaHeberg) {
            return datD <= dataResaHeberg.date_fin && datF >= dataResaHeberg.date_debut
        }).length == 0) {
            if (this.mGetLstHebergementAgendaCentraleRdv().filter(function (dataResaHebergExt) {
                return (datD >= dataResaHebergExt.date_debut && datD <= dataResaHebergExt.date_fin) ||
                    (typeof dateFin != 'undefined' && datF >= dataResaHebergExt.date_debut && datF <= dataResaHebergExt.date_fin)
            }).length == 0) {
                if (objet.data.is_virtuel == "1") {
                    //on vérifie chaque hebergement de l'hébergement virtuel
                    var isLibre = true
                    for (const dataHeberg of this.mGetLstHebergementLinked()) {
                        isLibre = objet.bddRef.getObjet(dataHeberg).objetMetier.mIsLibre(dateDebut, dateFin, dataReservationEnCours)
                        if (!isLibre) break;
                    }
                    return isLibre
                } else {
                    return true
                }
            } else {
                return false
            }
        } else { return false }
    }

    //si tarif, pour tester le tarif
    this.mGetPrixPersonneNuit = function (dat, nbPers, nbNuitTotal, tarif = null) {
        var prixFinalTtcJour = 0
        if (!tarif) {
            var tarifPuTtc = this.mGetTarifEtPuTTCFromDate(dat)
            if (tarifPuTtc.tarif) {
                prixFinalTtcJour = objet.bddRef.getObjet(tarifPuTtc.tarif).objetMetier.mGetPrixPersonneNuit(dat, nbPers, nbNuitTotal)
                if (prixFinalTtcJour == 0) prixFinalTtcJour = tarifPuTtc.puttc
            } else {
                prixFinalTtcJour = tarifPuTtc.puttc
            }
            if (prixFinalTtcJour == 0) {
                //on a pas trouvé de tarif, on prend l'autre
                if (tarifPuTtc.isBasseSaison) {
                    tarifPuTtc.tarif = Me.mGetTarifHaute()
                    tarifPuTtc.puttc = objet.data.puttc_haute
                } else {
                    tarifPuTtc.tarif = Me.mGetTarifBasse()
                    tarifPuTtc.puttc = objet.data.puttc_basse
                }
                tarifPuTtc.isBasseSaison = !tarifPuTtc.isBasseSaison

                if (tarifPuTtc.tarif) {
                    prixFinalTtcJour = objet.bddRef.getObjet(tarifPuTtc.tarif).objetMetier.mGetPrixPersonneNuit(dat, nbPers, nbNuitTotal)
                    if (prixFinalTtcJour == 0) prixFinalTtcJour = tarifPuTtc.puttc
                } else {
                    prixFinalTtcJour = tarifPuTtc.puttc
                }
            }
        } else {
            //test tarif
            prixFinalTtcJour = objet.bddRef.getObjet(tarif).objetMetier.mGetPrixPersonneNuit(dat, nbPers, nbNuitTotal)
            if (prixFinalTtcJour == 0) {
                if (tarif.id_hebergement_tarif == Me.objet.data.id_hebergement_tarif_basse) {
                    prixFinalTtcJour = Me.objet.data.puttc_basse
                } else {
                    prixFinalTtcJour = Me.objet.data.puttc_haute
                }
                if (prixFinalTtcJour == 0) {
                    if (tarif.id_hebergement_tarif == Me.objet.data.id_hebergement_tarif_basse) {
                        prixFinalTtcJour = Me.objet.data.puttc_haute
                    } else {
                        prixFinalTtcJour = Me.objet.data.puttc_basse
                    }
                }
            }
        }
        //var puttc = (objet.data.puttc ? objet.data.puttc : 0)


        //if (tarif) {
        //    prixFinalTtcJour = objet.bddRef.getObjet(tarif).objetMetier.mGetPrixPersonneNuit(dat, nbPers, nbNuitTotal)
        //    if (prixFinalTtcJour == 0) prixFinalTtcJour = puttc
        //} else {
        //    prixFinalTtcJour = puttc
        //}

        return prixFinalTtcJour

        //if (simulTarif.objTarif) {
        //    prix = simulTarif.objTarif.objetMetier.mGetPrixPersonneNuit(itemData.date, simulTarif.nbPers, simulTarif.nbNuit)
        //    if (prix == 0 && objHebergementForOccupe) {
        //        txt = parseFloat(objHebergementForOccupe.data.puttc) + "€"
        //    } else {
        //        txt = parseFloat(prix) + "€"
        //    }
        //} else {
        //    if (objHebergementForOccupe && objHebergementForOccupe.data.puttc) {
        //        txt = parseFloat(objHebergementForOccupe.data.puttc) + "€"
        //    } else {
        //        txt = parseFloat(0) + "€"
        //    }
        //}
    }

    this.mGetPrixSurPeriode = function (dateDebut, dateFin, nbPers) {
        var totTtc = 0
        var nbNuit = mGetNbNuits(dateDebut, dateFin)
        dateFin = (new Date(dateFin)).addDays(-1)
        do {
            totTtc += Me.mGetPrixPersonneNuit(dateDebut, nbPers, nbNuit)
            dateDebut = (new Date(dateDebut)).addDays(1)
        } while ((new Date(dateDebut)).addDays(-1).toDDMMAA() != dateFin.toDDMMAA());
        return totTtc
    }

    this.mGetLstHebergementLibreWithTxOccup = function (dateDebut, dateFin, nbPers, dataReservationEnCours) {
        var lst = []
        this.mGetLstHebergement().filter(function (ch) { return ch.date_abandon == null }).forEach(function (ch) {
            var obj = Me.objet.bddRef.getObjet(ch)
            if (obj.objetMetier.mIsLibre(dateDebut, dateFin, dataReservationEnCours) && (!nbPers || nbPers <= obj.objetMetier.mGetNbPlaceMax())) {
                lst.push(obj.objetMetier.mGetMaxTauxOccupation(nbPers))
            }

        })
        return lst
    }

    this.mGetLstHebergementConfig = function () {
        return Me.objet.bddRef.mGetArray("hebergement_config").filter(function (chConf) { return chConf.id_hebergement == objet.data.id_hebergement })
    }

    this.mGetMaxTauxOccupation = function (nbPersonne) {
        var configMax = this.mGetMaxConfig()
        var occup = Me.mGetOccupationWithConfig(configMax, nbPersonne)
        return occup
    }

    this.mGetOccupationWithConfig = function (config, nbPersonne) {
        var nbPlaceMax = config.nb_grand_lit * 2 + parseInt(config.nb_petit_lit)
        //var nbPlaceUtilise = nbPersonne
        return {
            hebergement: objet.data,
            config: config,
            taux_occupation: nbPersonne / nbPlaceMax * 100,
            nb_place_utilise: nbPersonne,
            manque_lit: nbPersonne > nbPlaceMax
        }
    }

    this.mGetNbPlaceMax = function () {
        var config = this.mGetMaxConfig()
        return (config ? config.nb_grand_lit * 2 + config.nb_petit_lit * 1 : 0)
    }

    this.mGetMaxConfig = function () {
        var maxConfig = null
        if (objet.data.is_virtuel == "1") {
            var conf = { nb_grand_lit: 0, nb_petit_lit: 0 }
            this.mGetLstHebergementLinked().forEach(function (dataHeberg) {
                var config = objet.bddRef.getObjet(dataHeberg).objetMetier.mGetMaxConfig()
                conf.nb_grand_lit += config.nb_grand_lit
                conf.nb_petit_lit += config.nb_petit_lit
            })
            return conf
        } else {
            this.mGetLstHebergementConfig().forEach(function (conf) {
                if (maxConfig == null) { maxConfig = conf }
                else if (parseInt(maxConfig.nb_grand_lit) * 2 + parseInt(maxConfig.nb_petit_lit) < parseInt(conf.nb_grand_lit) * 2 + parseInt(conf.nb_petit_lit)) { maxConfig = conf }
            })
        }
        return maxConfig
    }

    this.mGetMinConfig = function () {
        var minConfig = null
        if (objet.data.is_virtuel == "1") {
            var conf = { nb_grand_lit: 0, nb_petit_lit: 0 }
            this.mGetLstHebergementLinked().forEach(function (dataHeberg) {
                var config = objet.bddRef.getObjet(dataHeberg).objetMetier.mGetMinConfig()
                conf.nb_grand_lit += config.nb_grand_lit
                conf.nb_petit_lit += config.nb_petit_lit
            })
            return conf
        } else {
            if (this.mGetLstHebergementConfig().length > 1) {
                this.mGetLstHebergementConfig().forEach(function (conf) {
                    if (minConfig == null) { minConfig = conf }
                    else if (parseInt(minConfig.nb_grand_lit) * 2 + parseInt(minConfig.nb_petit_lit) > parseInt(conf.nb_grand_lit) * 2 + parseInt(conf.nb_petit_lit)) { minConfig = conf }
                })
            }
        }
        return minConfig
    }

    this.mGetMaxNbPersonneHebergement = function () {
        var maxConfig = this.mGetMaxConfig()
        return maxConfig.nb_grand_lit * 2 + maxConfig.nb_petit_lit
    }

    this.mGetMaxNbPersonneAllHebergement = function () {
        var nbMax = 0
        Me.objet.bddRef.mGetArray("hebergement").forEach(function (ch) {
            var maxConfig = Me.objet.bddRef.getObjet(ch).objetMetier.mGetMaxConfig()
            if (maxConfig) {
                if (nbMax < parseInt(maxConfig.nb_grand_lit) * 2 + parseInt(maxConfig.nb_petit_lit)) {
                    nbMax = parseInt(maxConfig.nb_grand_lit) * 2 + parseInt(maxConfig.nb_petit_lit)
                }
            }
        })
        return nbMax
    }

    this.mGetHebergementConfigDefaut = function () {
        return Me.objet.bddRef.mGetArray("hebergement_config")
            .filter(function (chConf) { return chConf.id_Hebergement == objet.data.id_Hebergement })
            .sort(function (o1, o2) { return o1.tri - o2.tri })[0]
    }

    this.mGetLstBestHebergementConfigWithAdulteEnfant = function (nbAdulte, nbEnfant) {
        function scoreEfficacite(config) {

            let adultCapacity = config.nb_grand_lit * 2;
            let childCapacity = config.nb_petit_lit;

            let totalCapacity = adultCapacity + childCapacity;
            let totalPeople = nbAdulte + nbEnfant;

            let adultsPlaced = Math.min(nbAdulte, adultCapacity);
            let remainingAdults = nbAdulte - adultsPlaced;

            let childrenPlaced = Math.min(nbEnfant, childCapacity);
            let remainingChildren = nbEnfant - childrenPlaced;

            // enfants utilisent les grands lits restants
            let remainingAdultCapacity = adultCapacity - adultsPlaced;
            let extraChildren = Math.min(remainingChildren, remainingAdultCapacity);
            remainingChildren -= extraChildren;

            // ❌ si quelqu’un n’est pas logé → score nul
            if (remainingAdults + remainingChildren > 0) return 0;

            // 🎯 efficacité de remplissage
            let usedBeds = adultsPlaced + childrenPlaced + extraChildren;

            let efficiency = usedBeds / totalCapacity;

            // 🎯 bonus : éviter le surdimensionnement
            let tightness = totalPeople / totalCapacity;

            return (efficiency * 100) + (tightness * 50);
        }

        var lst = []
        this.mGetLstHebergementConfig().forEach(function (config, idx) {
            let s = scoreEfficacite(config);
            lst.push({ score: s, config: config })
        })

        var lstData = []
        lst.sort(function (o1, o2) { return o2.score - o1.score }).forEach(function (item) {
            lstData.push(item.config)
        })
        return lstData
    }

    this.isBasseSaison = function (dat) {
        var lstPeriodeBasse = Me.objet.bddRef.paraAppli.mGetPara("hebergement_periode_basse_saison")
        var datMj = (dat.getMonth() + 1) * 100 + dat.getDate()
        var isBasseSaison = false
        lstPeriodeBasse.forEach(function (cplDat) {
            if (cplDat.length == 2) {
                var datDebut = (cplDat[0].getMonth() + 1) * 100 + cplDat[0].getDate()
                var datFin = (cplDat[1].getMonth() + 1) * 100 + cplDat[1].getDate()
                if (datMj >= datDebut && datMj <= datFin) isBasseSaison = true
            }
        })
        return isBasseSaison
    }
    this.mGetTarifEtPuTTCFromDate = function (dat) {
        if (this.isBasseSaison(dat)) {
            return { tarif: this.mGetTarifBasse(), puttc: Me.objet.data.puttc_basse, isBasseSaison: true }
        } else {
            return { tarif: this.mGetTarifHaute(), puttc: Me.objet.data.puttc_haute, isBasseSaison: false }
        }
    }
    this.mGetTarifHaute = function () {
        var tarif = Me.objet.bddRef.mGetArray("hebergement_tarif").filter(function (tarif) { return tarif.id_hebergement_tarif == objet.data.id_hebergement_tarif_haute })[0]
        return ((typeof tarif == 'undefined') ? null : tarif)
    }
    this.mGetTarifBasse = function () {
        var tarif = Me.objet.bddRef.mGetArray("hebergement_tarif").filter(function (tarif) { return tarif.id_hebergement_tarif == objet.data.id_hebergement_tarif_basse })[0]
        return ((typeof tarif == 'undefined') ? null : tarif)
    }

    //this.mGetTarifInternet = function () {
    //    var tarif = Me.objet.bddRef.mGetArray("hebergement_tarif").filter(function (tarif) { return tarif.id_hebergement_tarif == objet.data.id_hebergement_tarif_internet })[0]
    //    return ((typeof tarif == 'undefined') ? null : tarif)
    //}

    this.mGetDataFichierTable = function () {
        if (objet.data.id_fichier_table != null) {
            return Me.objet.bddRef.mGetArray("fichier_table").filter(function (ficTable) { return ficTable.id_fichier_table == objet.data.id_fichier_table })[0]
        } else { return null }
    }
    this.mGetUrlFichierTable = function () {
        var dataFichierTable = this.mGetDataFichierTable()
        if (dataFichierTable) {
            return "/Fichier/" + Me.objet.bddRef.nom_base + "/bdd/fichier_table/" + dataFichierTable.id_fichier_table + "/" + dataFichierTable.nom
        } else { return "" }
    }


    this.isPopupFullScreen = false
    this.mGetPopupPositionWidthHeight = function () {
        return {
            width: "650",
            height: "100%",
            maxHeight: "100%",
            position: {
                my: "right bottom",
                at: "right bottom",
                of: "body",
                //offset: { x: -50, y: -25 }
            }
        }
    }
    this.mGetDisplayInPopup = function (newValue) {
        if (typeof objet.bddRef.utiCourantParaJson["dataDisplayInPopup_" + objet.mGetTable().nom] == 'undefined') {
            objet.bddRef.utiCourantParaJson["dataDisplayInPopup_" + objet.mGetTable().nom] = true
        }
        if (typeof newValue != 'undefined') {
            objet.bddRef.utiCourantParaJson["dataDisplayInPopup_" + objet.mGetTable().nom] = newValue
            objet.bddRef.mSaveParaJsonUtilisateur();
        }
        return objet.bddRef.utiCourantParaJson["dataDisplayInPopup_" + objet.mGetTable().nom]
    }
    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
        var dxCtrl = $("<div style='height:100%;width:100%;'/>").appendTo(contentElement).dxCtrlContentHebergement({
            bddCtrl: Me.objet.bddRef,
            data: objet.data,
            optionPopup: option
        }).dxCtrlContentHebergement("instance")
    }

    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        if (dataTemplate.date_abandon) contentElement.closest(".divtemplate").addClass("hebergement_disable_reservation_cell")

        if (parametre.isPhone) {
            var $Table = $("<table style='width:100%;'/>").appendTo(contentElement)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:1px' rowspan='2'/>").appendTo($Tr)
            var dxCtrlImage = $("<div style='width:100%;height:100%;'/>").appendTo($Td).dxCtrlImageData({
                bddCtrl: objet.bddRef,
                size: 100,
                id_table: objet.bddRef.table.mGetItemFromNom("hebergement").id_table,
                id: dataTemplate.id_key,
                showTextOnImage: false,
                fontSizeText: "30px"
            }).dxCtrlImageData("instance");
            var $TdNom = $("<td style='width:100%' colspan='2'/>").appendTo($Tr)
            $("<div style='overflow:hidden;text-overflow:ellipsis;width:100%;padding:0 3px;font-weight:bold;'>" + dataTemplate.nom + "</div>").appendTo($TdNom)
            var $Tr = $("<tr/>").appendTo($Table)
            var $TdNom = $("<td style='width:100%'/>").appendTo($Tr)
            var $TdChoix = $("<td style='width:1px;text-align:center;'/>").appendTo($Tr)
            option.contentTemplateRight($TdChoix)

            mRempliDescription(contentElement)
            mRempliPrestation(contentElement)
            mRempliConfig(contentElement)
            mRempliFicTab(contentElement)
        } else {
            var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(contentElement)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:145px;padding-right:5px;vertical-align:top;'/>").appendTo($Tr)
            var dxCtrlImage = $("<div style='width:100%;height:100%;'/>").appendTo($Td).dxCtrlImageData({
                bddCtrl: objet.bddRef,
                size: 140,
                id_table: objet.bddRef.table.mGetItemFromNom("hebergement").id_table,
                id: dataTemplate.id_key,
                showTextOnImage: false,
                fontSizeText: "30px"
            }).dxCtrlImageData("instance");

            var $Td = $("<td style='width:100%;vertical-align:top;white-space:normal;'/>").appendTo($Tr)
            $("<div style='overflow:hidden;text-overflow:ellipsis;width:100%;padding:0 3px;font-weight:bold;'>" + dataTemplate.nom + "</div>").appendTo($Td)
            mRempliDescription($Td)
            mRempliPrestation($Td)
            mRempliConfig($Td)
            mRempliFicTab($Td)
        }

        function mRempliDescription(content) {
            var $DivDescription = $("<div style='text-align:right;'/>").appendTo(content)
            var $DivDescriptionInner = $("<div style='overflow:hidden;text-overflow:ellipsis;width:100%;padding:0 3px;font-style:italic;line-height:1.2;font-size: 90%;text-align:left;' class='ellipsismultiligne5'>" + dataTemplate.description + "</div>").appendTo($DivDescription)
            var $AVoirPlus = $("<a href='javascript:void(0)'>Voir plus</a>").appendTo($DivDescription)
            var showPlus = false
            resizeObserver.mAdd($DivDescription, function () {
                if (showPlus) {
                    $AVoirPlus.show()
                } else {
                    var el = $DivDescriptionInner[0]
                    // texte tronqué si le contenu dépasse la hauteur visible du bloc
                    if (el.scrollHeight > el.clientHeight + 1) {
                        $AVoirPlus.show()
                    } else {
                        $AVoirPlus.hide()
                    }
                }
            })()
            $AVoirPlus.on("click", function (e) {
                e.stopPropagation()
                if ($(this).text() == "Voir plus") {
                    $DivDescriptionInner.removeClass("ellipsismultiligne5")
                    $(this).text("Voir moins")
                    showPlus = true
                } else {
                    $DivDescriptionInner.addClass("ellipsismultiligne5")
                    $(this).text("Voir plus")
                    showPlus = false
                }
            })
        }
        function mRempliPrestation(content) {
            if (dataTemplate.lst_prestation) {
                var txtPresta = ""
                dataTemplate.lst_prestation.split("|:§|").forEach(function (presta) {
                    txtPresta += (txtPresta.length > 0 ? " &bull; " : "") + presta
                })
                $("<div style='overflow:hidden;text-overflow:ellipsis;width:100%;padding:0 3px;font-family:barlow condensed;line-height:1;padding:5px 0;'>" + txtPresta + "</div>").appendTo(content)
            }
        }
        function mRempliConfig(content) {
            if (dataTemplate.is_virtuel == "0") {
                if (dataTemplate.lst_config) {
                    var htmlConfig = ""
                    var htmlConfiTooltip = ""
                    var lstConfig = []
                    dataTemplate.lst_config.split("|").forEach(function (config) {
                        lstConfig.push({ nb_grand_lit: config.split(",")[0], nb_petit_lit: config.split(",")[1] })
                    })
                    mRempliHtmlconfig(lstConfig, content)
                    //dataTemplate.lst_config.split("|").forEach(function (config) {
                    //    var nbGrdLit = config.split(",")[0]
                    //    var nbPetitLit = config.split(",")[1]
                    //    var result = (nbGrdLit > 0 ? "<b>" + nbGrdLit + "</b><i class='fafa-grand-lit' style='color:" + theme.color + ";'></i>" : "") + (nbPetitLit > 0 ? "<b>" + nbPetitLit + "</b><i class='fafa-petit-lit' style='color:" + theme.color + ";'></i>" : "")
                    //    var resulttoolTip = (nbGrdLit > 0 ? nbGrdLit + " grand lit" : "") + (nbGrdLit > 0 && nbPetitLit > 0 ? " et " : "") + (nbPetitLit > 0 ? nbPetitLit + " petit lit" : "")
                    //    if (result.length > 0) {
                    //        htmlConfig += (htmlConfig.length > 0 ? "<span style='font-size:100%;opacity:0.5;'>&nbsp; &bull; &nbsp;</span>" : "") + result
                    //        htmlConfiTooltip += "<div>" + resulttoolTip + "</div>"
                    //    }
                    //})
                    //$("<div style='overflow:hidden;text-overflow:ellipsis;width:100%;padding:0 3px;padding-top:3px;'>" + htmlConfig + "</div>").appendTo(content).attr("title", "<div style='text-align:left;'>" + (dataTemplate.lst_config.length > 1 ? "<div style='font-weight:bold;'>Plusieurs configurations:</div>" : "") + htmlConfiTooltip + "</div>")
                }
            } else {
                objet.bddRef.mGetArray("hebergement_hebergement").filter(function (o) {
                    return o.id_hebergement_virtuel == dataTemplate.id_hebergement
                }).forEach(function (dataHebergHeberg, idx) {
                    var objHeberg = objet.bddRef.getObjet("hebergement", dataHebergHeberg.id_hebergement)
                    var lstConfig = objHeberg.objetMetier.mGetLstHebergementConfig()
                    if (lstConfig.length > 0) {
                        if (idx > 0) $("<span>&nbsp;<b>|</b></span>").appendTo($Td)
                        $("<span/>").appendTo($Td).text(objHeberg.data.nom)
                        $("<span/>").appendTo($Td).html("&nbsp;&bull; ")
                        var $Span = $("<span/>").appendTo($Td)
                        mRempliHtmlconfig(lstConfig, $Span)
                    }
                })
            }

            function mRempliHtmlconfig(lstConfig, contentElement) {
                var htmlConfig = ""
                var htmlConfiTooltip = ""
                lstConfig.forEach(function (config) {
                    var nbGrdLit = config.nb_grand_lit
                    var nbPetitLit = config.nb_petit_lit
                    var result = (nbGrdLit > 0 ? "<b>" + nbGrdLit + "</b><i class='fafa-grand-lit' style='color:" + theme.color + ";'></i>" : "") + (nbPetitLit > 0 ? "<b>" + nbPetitLit + "</b><i class='fafa-petit-lit' style='color:" + theme.color + ";'></i>" : "")
                    var resulttoolTip = (nbGrdLit > 0 ? nbGrdLit + " grand lit" : "") + (nbGrdLit > 0 && nbPetitLit > 0 ? " et " : "") + (nbPetitLit > 0 ? nbPetitLit + " petit lit" : "")
                    if (result.length > 0) {
                        htmlConfig += (htmlConfig.length > 0 ? "<span style='font-size:100%;opacity:0.5;'>&nbsp; &bull; &nbsp;</span>" : "") + result
                        htmlConfiTooltip += "<div>" + resulttoolTip + "</div>"
                    }
                })
                $("<span style='overflow:hidden;text-overflow:ellipsis;width:100%;padding:0 3px;padding-top:3px;'>" + htmlConfig + "</div>").appendTo(contentElement).attr("title", "<div style='text-align:left;'>" + (lstConfig.length > 1 ? "<div style='font-weight:bold;'>Plusieurs configurations:</div>" : "") + htmlConfiTooltip + "</span>")
            }
        }
        function mRempliFicTab(content) {
            var $Div = $("<div style='width:100%;white-space:nowrap;overflow:hidden;'/>").appendTo(content)
            var dxCtrlFicTab = $("<div style='width:100%;height:100%;'/>").appendTo($Div).dxCtrlFichier2Table({
                bddCtrl: objet.bddRef,
                accept: ".png,.jpg,.jpeg,.gif,.bmp",
                id: dataTemplate.id_key,
                id_table: objet.bddRef.table.mGetItemFromNom("hebergement").id_table,
                readOnly: true,
                typeVisu: "lst"
            }).dxCtrlFichier2Table("instance")
        }


    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus) {
        $("<div style='' title='Créé le " + dataPlus.dcr.toFrenchDateTime() + "'><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</div>").appendTo(contentElement)
        $("<div style='' title='Modifié le " + dataPlus.dmo.toFrenchDateTime() + "'><i class='fas fa-pen dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dmo.toDateIlya(true) + "</div>").appendTo(contentElement)
    }

}